export default __webpack_public_path__ + "static/social-top50_en-a34f97f1cbadf7a94e2e4f38fb6cd967.png";